import Link from '@/routing/Link'
import { Heading } from '@/components/ui/Heading'
import { Text } from '@/components/ui/Text'
import { Button } from '@/components/ui/button'
import { ArrowRight, Sparkles } from '@digital-twins/design-system/icons'
import { useAuth } from '@/lib/config/auth-provider'
import { HomeStage } from './HomeStage'

// Referral capture (?ref= -> cookie + redirect to /register) is no longer owned by this
// page — Step 12 (docs/plans/assistant-mvp-plan.md, D1d) extracted it to
// `useReferralCapture`, mounted once at the route layer (`HomeEntryLayout` in
// AppRoutes.tsx) so it applies regardless of which component renders at `/`,
// `/home-lab` or `/home-classic`. Do not re-add a local copy here.
export default function HomePage() {
  const { isAuthenticated, isLoading: authLoading } = useAuth()

  if (authLoading) {
    return <div className="min-h-screen bg-background" />
  }

  if (!isAuthenticated) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
        <div className="mx-auto flex w-full max-w-md flex-col items-center gap-6 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground">
            <Sparkles className="h-6 w-6" />
          </div>

          <div className="flex flex-col gap-3">
            <Heading level={1} size="3xl" className="font-bold">
              Know what your customers think.
            </Heading>
            <Text size="lg" color="muted">
              In minutes, not months.
            </Text>
          </div>

          <Button size="lg" asChild className="w-full">
            <Link href="/login">
              Get Started
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    )
  }

  return <HomeStage />
}
